'use client';
import styled from 'styled-components';
import arrowLeft from '../../images/Icons/arrow-left.svg';
import search from '../../images/Icons/search.svg';

export const SearchContainer = styled.div`
  border: 1px solid transparent;
  border-radius: 32px;
  background: ${props => props.theme.colors.background.lightest};
  position: relative;
  max-width: 600px;
  margin: 0 auto ${props => props.theme.spacing(8)};

  &:before {
    content: '';
    background-image: url(${search});
    background-size: 18px 18px;
    width: 18px;
    height: 18px;
    position: absolute;
    left: 24px;
    top: 22px;
  }

  &:focus-within {
    border: 1px solid ${props => props.theme.colors.border.dark};
  }
`;

export const SearchInput = styled.input`
  ${props => props.theme.typography.body}
  height: 60px;
  width: 100%;
  padding-left: 52px;
  border: none;
  background-color: transparent;
  border-radius: 32px;

  &:focus,
  &:focus-within,
  &:focus-visible {
    outline: none;
    box-shadow: none;
    border: none;
  }
`;

export const FaqContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${props => props.theme.spacing(10)};
  margin-top: ${props => props.theme.spacing(8)};

  @media ${props => props.theme.tablet} {
    > * {
      flex-basis: calc(50% - ${props => props.theme.spacing(10)});
    }
  }
`;

export const FaqSection = styled.div`
  border-radius: 32px;
  background: ${props => props.theme.colors.background.lightest};
  padding: ${props => props.theme.spacing(12, 10)};
`;

export const FaqSectionHeader = styled.h3`
  ${props => props.theme.typography.heading4}
  margin-bottom: ${props => props.theme.spacing(6)};
`;

export const FaqItem = styled.div`
  ${props => props.theme.typography.button}
  margin-bottom: ${props => props.theme.spacing(4)};
`;

export const FaqItemLink = styled.a`
  color: ${props => props.theme.colors.hero.plum};
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const AnswerDetail = styled.div`
  border-radius: 32px;
  background: ${props => props.theme.colors.background.lightest};
  padding: ${props => props.theme.spacing(18, 10)};
  margin: ${props => props.theme.spacing(8)} auto 0;

  h2 {
    ${props => props.theme.typography.heading2}
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const AnswerContent = styled.div`
  ${props => props.theme.typography.body}

  a {
    color: ${props => props.theme.colors.hero.plum};
  }

  ul,
  ol {
    padding-left: ${props => props.theme.spacing(6)};
    margin-bottom: ${props => props.theme.spacing(4)};
  }

  p {
    margin-bottom: ${props => props.theme.spacing(4)};
  }
`;

export const BackLink = styled.a`
  ${props => props.theme.typography.body}
  color: ${props => props.theme.colors.text.primary};
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.spacing(10)};
  cursor: pointer;

  &:before {
    content: '';
    background-image: url(${arrowLeft});
    background-size: 20px 14px;
    width: 20px;
    height: 14px;
    position: relative;
    margin-right: ${props => props.theme.spacing(4)};
  }
`;
